import { NOTE_STATUS_LABELS, type Note } from "@/services/api";
import type { FC } from "react";
import styles from "./styles.module.scss";

const getColor = (noteStatus: Note["status"]) => {
  switch (noteStatus) {
    case "TO_DO":
      return "#CF2C23";
    case "DONE":
      return "Done";
    case "IN_PROGRESS":
      return "#D48806";
  }
};

type Props = {
  noteStatus: NonNullable<Note["status"]>;
};

export const StatusText: FC<Props> = ({ noteStatus }) => {
  return (
    <p className={styles["status-text"]} style={{ color: getColor(noteStatus) }}>
      {NOTE_STATUS_LABELS[noteStatus]}
    </p>
  );
};
